export default __webpack_public_path__ + "static/media/Melanin.c0476086.jpg";